import React from "react";
import NavbarMenu from "../heroSection/NavbarMenu";
import VehicleLoginForm from "./VehicleLoginForm";
import Footer from "../../components/footer/Footer";
import { useTranslation } from "react-i18next";
import SEO from "../SEO";

export default function VehicleLoginPage() {
  const { t } = useTranslation();
  return (
    <>
      <SEO
        title="TransCirox – Vehicle Login"
        description="Login to your TransCirox vehicle account to manage your orders."
      />
      <NavbarMenu />
      <VehicleLoginForm />
      <Footer />
    </>
  );
}
